import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
import { Text, Layer, Group, Path} from 'react-konva';

const colors = new Colors();
const DOUBLE_CLICK = 300;

const PlaneMacro = memo(({
    debug,
    setMacroToShow,
    isShowing, startDragging, isSelected, macro, coordinates
}) => {

    let {x,y,diameter} = macro.getGeometry();
    let lastClick = useRef(new Date().getTime());
    // center
    //let {x,y} = coordinates;

    const onClick = useCallback(() => {
        let now = new Date().getTime();
        if (now - lastClick.current <= DOUBLE_CLICK) {
            setMacroToShow(macro);
        }
        lastClick.current = now;
    }, [setMacroToShow]);

    let d = macro.getBlob(x,y, debug);
    // let hull  = macro.getConvexHull(x,y, debug);
    let fill = colors.getColorForHash(macro.id);
    let radius = diameter / 2;
    let className = "macro";
    if (isSelected) {
        className += " selected";
    }
    if (isShowing) {
        className += " showing";
    }
        
    return (
        <Group>
         <Path
           perfectDrawEnabled={false}
           hitStrokeWidth={0}
           shadowForStrokeEnabled={false}
           dash={isSelected && [3,2]}
           onClick={onClick}
           onMouseDown={(e) => startDragging(e.evt, macro)}
           fill={colors.transparent(colors.saturate(fill, 2), isSelected ? 0.2 : 0.5)}
           strokeWidth={1}
           data={d} className={className} stroke={isShowing || isSelected ? "white" : "transparent"}/>
          {/*hull.map(({x,y}, i) => <Text fontSize={8} x={x+9} y={y} text={((hull.length - i)%hull.length) + ' (' + x + ',' + y + ')'} fill="white"/>)*/}
        </Group>
    );
          /*
          <circle
            className={className}
            onMouseDown={(e) => startDragging(e, macro)}
            cx={x}
            cy={y}
            r={5}
            fill={fill}
            stroke={fill}
          />
          <text
            onMouseDown={(e) => startDragging(e, macro)}
            x={x - 3} y={y + 5} className={isSelected ? "selected macro-text" : "macro-text"}>{macro.number}</text>
           */
});

const mapStateToProps = (state, props) => {
    let x ={
    };
    props.effect._parameters
        .filter(p => p.planeMacro === props.macro)
        .map(
        p => x[p.id] = state.effects.effectParameters[p.id]);
    props.effect._parameters
        .filter(p => p.planeMacro === props.macro)
        .map(
        p => x[p.id + 'depth'] = p.depth);
    return x;
};



export default connect(mapStateToProps, null)(PlaneMacro);
